<template>
    <div class="input-file">
        <label :for="id" v-if="!loading">
            <span v-if="!hasCertificate">Ajouter un certificat</span>
            <span v-else>Modifier le certificat</span>
        </label>
        <div v-else>
            <uni-loading-button is-disable="true"></uni-loading-button>
        </div>
        <input style="margin-bottom: 1rem" type="file" :id="id" @change="change">
    </div>
</template>
<script>
    import UniButton from "./UniButton";
    import UniLoadingButton from "../b-patterns/UniLoadingButton";

    export default {
        name: 'InputFile',
        components: {UniLoadingButton, UniButton},
        props: {
            id: String,
            label: String,
            loading: Boolean,
            hasCertificate: Boolean
        },
        methods: {
            change(e) {
                this.$emit('change', e)
            }
        }

    }
</script>
<style lang="scss" scoped>
    label {
        text-align: center;
        height: 40px;
        border-radius: var(--radius-default);
        background: var(--color-primary-light);
        color: var(--color-primary);
        font-weight: var(--font-weight-bold);
        padding: var(--s-xs);
        cursor: pointer;
        width: 100%;
        transition: var(--transition-quick);
        background: var(--color-primary-light-2);
        &:hover {
            background: var(--color-primary);
            color: var(--color-white);
        }
    }
    input {
        width: 0.1px;
        height: 0.1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;
    }

    @include screen-m {
        label {
            width: auto;
        }
    }
</style>
